const getProgressPercentSimple = (progressSoFar: number, progressTotal: number): number => {
  if (progressTotal === 0) {
    return 0;
  }
  return Math.floor((progressSoFar / progressTotal) * 100);
};

export default getProgressPercentSimple;
